<template>
    <div class="card card-aberto text-center mt-3" :id="'card' + equip.id">
        <!-- titulo -->
        <div class="card-header card1 d-flex" :id="'subCard' + equip.id" :class="{
            'bateriaFraca !important': ((equip.possuiBateria && (equip.bateria <= config.perigoBateria)) || (config.perigoInatividade <= equip.tempoAtualizacao)),
            'bateriaAlerta': (equip.possuiBateria && (config.perigoBateria < equip.bateria) && (equip.bateria < config.alertaBateria) ||
                (config.perigoInatividade > equip.tempoAtualizacao && (equip.tempoAtualizacao > config.alertaInatividade)))
        }">
            <p class="card-text">
                Número de Série
                {{ equip.numSerie }}
            </p>
        </div>
        <!-- bateriaFracaOpaca -->
        <div class="card-body " :class="{
            'bateriaFracaOpaca !important':
                ((equip.possuiBateria && (equip.bateria <= config.perigoBateria)) || (config.perigoInatividade <= equip.tempoAtualizacao)),
            'bateriaAlertaOpaca': (equip.possuiBateria && (config.perigoBateria < equip.bateria) && (equip.bateria < config.alertaBateria) ||
                (config.perigoInatividade > equip.tempoAtualizacao && (equip.tempoAtualizacao > config.alertaInatividade)))
        }" v-if="(equip.possuiBateria === true)">
            <p class="card-text">
                {{ equip.leito.quarto.descricao }} - {{ equip.leito.descricao }}
            </p>
            <p class="card-text">
                {{ equip.leito.quarto.setor.descricao }}
            </p>
            <p class="card-text">
                Última Comunicação: {{ equip.tempoAtualizacaoDesc }}
            </p>
            <p class="card-text">
                Bateria Atual: {{ equip.bateria }}%
            </p>
            <div class="progress">
                <div class="progress-bar progress-bar-striped progress-bar-animated" :class="{
                    'bg-danger': (equip.bateria <= config.perigoBateria),
                    'bg-warning': (equip.bateria <= config.alertaBateria && equip.bateria >= config.perigoBateria),
                    'bg-success': (equip.bateria > config.perigoBateria)
                }" role="progressbar" aria-label="Low Batery Progress Bar" :style="'width: ' + equip.bateria + '%'"
                    aria-valuemin="0" aria-valuemax="100" />
            </div>
        </div>
        <div class="card-body justify-content-start" v-else :class="{
            'bateriaFracaOpaca':
                ((equip.possuiBateria && (equip.bateria <= config.perigoBateria)) || (config.perigoInatividade <= equip.tempoAtualizacao)),
            'bateriaAlertaOpaca':
                (equip.possuiBateria && (config.perigoBateria < equip.bateria) && (equip.bateria < config.alertaBateria) ||
                    (config.perigoInatividade > equip.tempoAtualizacao && (equip.tempoAtualizacao > config.alertaInatividade)))
        }">
            <p class="card-text">
                {{ equip.leito.quarto.descricao }} - {{ equip.leito.descricao }}
            </p>
            <p class="card-text">
                {{ equip.leito.quarto.setor.descricao }}
            </p>
            <p class="card-text">
                Última Comunicação:
                {{ equip.tempoAtualizacaoDesc }}
            </p>
            <p class="card-text">
                Bateria: {{ usaBateria(equip.possuiBateria) }}
            </p>
        </div>
    </div>
</template>

<script setup>

import store from '@/store/store';
import moment from 'moment';
import { defineProps, computed } from 'vue';

const props = defineProps(['equip']);

function formatarData(pData) {
    let d1 = pData;
    let d2 = new Date();
    const diffInMs = new Date(d2) - new Date(d1);
    var dias = Math.trunc(moment.duration(diffInMs).asDays());
    // if (d1 == d2) {
    //     return 'Hoje ás';
    // } else if (dias == 0) {
    //     return 'Hoje ás';
    // } else {
    //     return 'Há ' + dias + ' dia(s) ás ';
    // }
    return (d1 == d2 || dias == 0) ? 'Hoje ás' : 'Há ' + dias + ' dia(s) ás ';
}
function formatarHora(pHora) {
    let tempData = moment(pHora, "HH:mm:ss");
    return moment(tempData).format("HH:mm");
}
function usaBateria(pUsa) {
    return (pUsa) ? "Possui" : "Não Possui";
}

const config = computed(() => {
    return store.state.config;
});
const temporizadorLigado = computed(() => {
    return (store.state.config.cronometro) ? true : false;
});
</script>

<style scoped>
.card {
    width: auto;
    min-width: 500px !important;
    font-family: sans-serif;
}

.card-aberto {
    max-height: 325px !important;
}

.card-text,
.card-header {
    font-weight: bold;
    font-size: 1.3em;
    margin: 0;
}

.card-header {
    background-color: rgba(12, 139, 27, 0.6);
}

.card-body {
    background-color: rgba(18, 203, 40, 0.6);
}

.card-header {
    text-align: left;
    color: rgba(50, 50, 50, 0.75);
}

.card-body .card-text {
    text-align: left;
}

.card {
    box-shadow: 0px 10px 14px rgba(9, 82, 43, 0.2);
    /*min-width: 468px !important;*/
}

.card-body {
    display: flex !important;
    flex-direction: column;
    justify-content: center;
}

.card1 {
    padding-bottom: 1rem;
}

/*
.chamado1 {
    width: calc(var(--tamanho) * 3 * 1.6);
    height: calc(var(--tamanho) * 3.4);
}
.chamado2 {
    width: calc(var(--tamanho) * 3.4);
    height: calc(var(--tamanho) * 3.4);
}
.chamado3 {
    width: calc(var(--tamanho) * 4.8);
    height: calc(var(--tamanho) * 3.6);
}
*/
.bateriaFraca {
    background-color: #ea253c !important;
}

.bateriaFracaOpaca {
    background-color: rgba(234, 37, 60, 0.6) !important;
}

.bateriaAlerta {
    background-color: #efe446;
}

.bateriaAlertaOpaca {
    background-color: rgba(239, 228, 70, 0.6);
}


@media only screen and (max-width : 616px) {
    .card {
        width: auto;
        min-width: 430px;
        font-family: sans-serif;
    }
}

@media only screen and (max-width: 432px) {
    .card {
        min-width: 100%;
    }
}
</style>